<template>
  <div class="mybasics">
    <div class="title">基本资料</div>
    <el-form
      class="basics-form"
      ref="basicsForm"
      :model="formData"
      label-position="left"
      label-width="100px"
      :rules="rules"
    >
      <div class="form-item form-item-base">
        <el-form-item label="ID:">
          <el-input
            :disabled="true"
            readonly
            class="custom-input txt-normalstyle width270"
            :value="
              formData && formData.id_public_user_info
                ? formData.id_public_user_info
                : ''
            "
          ></el-input>
        </el-form-item>
        <el-form-item label="用户类型:" class="form-item-usertype">
          <el-input
            :disabled="true"
            readonly
            class="custom-input txt-normalstyle width270"
            :value="showUserType"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item
          label="身份:"
          prop="user_remark_002"
          :rules="rules.user_remark_002"
        >
          <CustomSelect
            :disabled="!formDataModifyStatus.user_remark_002"
            class="width690"
            style="min-height: 46px"
            :multiple-limit="3"
            multiple
            v-model="formData.user_remark_002"
            placeholder="请选择（最多3个）"
            popper-class="customselect-popper"
            value-key="value"
            otherValue="212"
          >
            <el-option
              v-for="(item, idx) in identityOptionsRegister"
              :key="idx"
              :label="item.text"
              :value="item"
              :remark="item.value"
            ></el-option>
          </CustomSelect>
        </el-form-item>
        <div class="buttons">
          <template v-if="!formDataModifyStatus.user_remark_002">
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_002', 1)
              "
              >修改
            </el-button>
          </template>
          <template v-if="formDataModifyStatus.user_remark_002">
            <el-button
              class="custom-button btn-determine btn-modify"
              @click="
                handleToConfirm('formDataModifyStatus', 'user_remark_002')
              "
              >确定
            </el-button>
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_002', 0)
              "
              >取消
            </el-button>
          </template>
        </div>
      </div>
      <div class="form-item form-item-normal" v-show="isSupplier">
        <el-form-item
          label="公司名称:"
          prop="user_remark_005"
          :rules="rules.user_remark_005"
        >
          <el-input
            :readonly="!formDataModifyStatus.user_remark_005"
            class="custom-input width690"
            v-model="formData.user_remark_005"
          ></el-input>
        </el-form-item>
        <div class="buttons">
          <template v-if="!formDataModifyStatus.user_remark_005">
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_005', 1)
              "
              >修改
            </el-button>
          </template>
          <template v-if="formDataModifyStatus.user_remark_005">
            <el-button
              class="custom-button btn-determine btn-modify"
              @click="
                handleToConfirm('formDataModifyStatus', 'user_remark_005')
              "
              >确定
            </el-button>
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_005', 0)
              "
              >取消
            </el-button>
          </template>
        </div>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item label="姓名:" prop="nick_name" :rules="rules.nick_name">
          <el-input
            :readonly="!formDataModifyStatus.nick_name"
            class="custom-input width690"
            v-model="formData.nick_name"
          ></el-input>
        </el-form-item>
        <div class="buttons">
          <template v-if="!formDataModifyStatus.nick_name">
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="handleToModify('formDataModifyStatus', 'nick_name', 1)"
              >修改
            </el-button>
          </template>
          <template v-if="formDataModifyStatus.nick_name">
            <el-button
              class="custom-button btn-determine btn-modify"
              @click="handleToConfirm('formDataModifyStatus', 'nick_name')"
              >确定
            </el-button>
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="handleToModify('formDataModifyStatus', 'nick_name', 0)"
              >取消
            </el-button>
          </template>
        </div>
      </div>
      <div class="form-item form-item-normal" v-show="isSupplier">
        <el-form-item
          label="开发地:"
          prop="user_remark_007"
          :rules="rules.user_remark_007"
        >
          <CustomSelectCity
            :disabled="!formDataModifyStatus.user_remark_007"
            class="width690"
            style="min-height: 46px"
            @changeLetter="handleChangeLetter"
            multiple
            v-model="formData.user_remark_007"
            placeholder="请选择"
            popper-class="customselect-popper"
            value-key="cityid"
          >
            <el-option
              v-for="(item, idx) in cityOptions"
              :key="idx"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </CustomSelectCity>
        </el-form-item>
        <div class="buttons">
          <template v-if="!formDataModifyStatus.user_remark_007">
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_007', 1)
              "
              >修改
            </el-button>
          </template>
          <template v-if="formDataModifyStatus.user_remark_007">
            <el-button
              class="custom-button btn-determine btn-modify"
              @click="
                handleToConfirm('formDataModifyStatus', 'user_remark_007')
              "
              >确定
            </el-button>
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_007', 0)
              "
              >取消
            </el-button>
          </template>
        </div>
      </div>
      <div class="form-item form-item-normal" v-show="isSupplier">
        <el-form-item
          label="团队人数:"
          prop="user_remark_006"
          :rules="rules.user_remark_006"
        >
          <el-input
            :readonly="!formDataModifyStatus.user_remark_006"
            class="custom-input width690"
            v-model="formData.user_remark_006"
          ></el-input>
        </el-form-item>
        <div class="buttons">
          <template v-if="!formDataModifyStatus.user_remark_006">
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_006', 1)
              "
              >修改
            </el-button>
          </template>
          <template v-if="formDataModifyStatus.user_remark_006">
            <el-button
              class="custom-button btn-determine btn-modify"
              @click="
                handleToConfirm('formDataModifyStatus', 'user_remark_006')
              "
              >确定
            </el-button>
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_006', 0)
              "
              >取消
            </el-button>
          </template>
        </div>
      </div>
      <div class="form-item form-item-normal" v-show="isSupplier">
        <el-form-item
          label="行业:"
          prop="user_remark_008"
          :rules="rules.user_remark_008"
        >
          <CustomSelect
            :disabled="!formDataModifyStatus.user_remark_008"
            class="width690"
            style="min-height: 46px"
            multiple
            v-model="formData.user_remark_008"
            placeholder="请选择"
            popper-class="customselect-popper"
            value-key="value"
            otherValue="810"
          >
            <el-option
              v-for="(item, idx) in industryOptions"
              :key="idx"
              :label="item.text"
              :value="item"
              :remark="item.value"
            >
            </el-option>
          </CustomSelect>
        </el-form-item>
        <div class="buttons">
          <template v-if="!formDataModifyStatus.user_remark_008">
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_008', 1)
              "
              >修改
            </el-button>
          </template>
          <template v-if="formDataModifyStatus.user_remark_008">
            <el-button
              class="custom-button btn-determine btn-modify"
              @click="
                handleToConfirm('formDataModifyStatus', 'user_remark_008')
              "
              >确定
            </el-button>
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_008', 0)
              "
              >取消
            </el-button>
          </template>
        </div>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item
          label="开发语言"
          prop="user_remark_003"
          :rules="rules.user_remark_003"
        >
          <CustomSelect
            :disabled="!formDataModifyStatus.user_remark_003"
            class="width690"
            style="min-height: 46px"
            :multiple-limit="3"
            multiple
            v-model="formData.user_remark_003"
            placeholder="请选择"
            popper-class="customselect-popper"
            value-key="value"
            otherValue="329"
          >
            <el-option
              v-for="(item, idx) in devlangOptions"
              :key="idx"
              :label="item.text"
              :value="item"
              :remark="item.value"
            >
            </el-option>
          </CustomSelect>
        </el-form-item>
        <div class="buttons">
          <template v-if="!formDataModifyStatus.user_remark_003">
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_003', 1)
              "
              >修改
            </el-button>
          </template>
          <template v-if="formDataModifyStatus.user_remark_003">
            <el-button
              class="custom-button btn-determine btn-modify"
              @click="
                handleToConfirm('formDataModifyStatus', 'user_remark_003')
              "
              >确定
            </el-button>
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_003', 0)
              "
              >取消
            </el-button>
          </template>
        </div>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item
          label="邮箱账号:"
          prop="user_email"
          :rules="rules.user_email"
        >
          <el-input
            :readonly="!formDataModifyStatus.user_email"
            class="custom-input width690"
            v-model="formData.user_email"
          ></el-input>
        </el-form-item>
        <div class="buttons">
          <template v-if="!formDataModifyStatus.user_email">
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="handleToModify('formDataModifyStatus', 'user_email', 1)"
              >修改
            </el-button>
          </template>
          <template v-if="formDataModifyStatus.user_email">
            <el-button
              class="custom-button btn-determine btn-modify"
              @click="handleToConfirm('formDataModifyStatus', 'user_email')"
              >确定
            </el-button>
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="handleToModify('formDataModifyStatus', 'user_email', 0)"
              >取消
            </el-button>
          </template>
        </div>
      </div>
      <div class="form-item form-item-normal upload" v-show="isSupplier">
        <el-form-item
          label="营业执照"
          prop="user_remark_019"
          :rules="rules.user_remark_019"
        >
          <el-upload
            class="upload-qualifications"
            action="no"
            accept=".png,.jpg"
            :disabled="!formDataModifyStatus.user_remark_019"
            :auto-upload="false"
            :multiple="false"
            :show-file-list="false"
            :on-change="(file, fileList) => {handleChangeFile(file);}"
          >
            <template v-if="formData.user_remark_019&&formData.user_remark_019.length>3">
              <el-image
                class="inner-qualifications"
                :src="formData.user_remark_019"
                :fit="fit"
              >
              </el-image>
              <div class="uploader_item_icon_wrap">
                <van-icon  @click="deleteImage(index)" name="delete" color="#dcdee0" style="font-size:1.1rem"/>
              </div>
            </template>
            <div v-else class="inner-qualifications-null"></div>
          </el-upload>
        </el-form-item>
        <div class="buttons">
          <template v-if="!formDataModifyStatus.user_remark_019">
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_019', 1)
              "
              >修改
            </el-button>
          </template>
          <template v-if="formDataModifyStatus.user_remark_019">
            <el-button
              class="custom-button btn-determine btn-modify"
              @click="
                handleToConfirm('formDataModifyStatus', 'user_remark_019')
              "
              >确定
            </el-button>
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_019', 0)
              "
              >取消
            </el-button>
          </template>
        </div>
      </div>
      <div class="form-item form-item-normal" v-show="isPublicist">
        <el-form-item
          label="涉猎领域"
          prop="user_remark_022"
          :rules="rules.user_remark_022"
        >
          <CustomSelect
            :disabled="!formDataModifyStatus.user_remark_022"
            class="width690"
            style="min-height: 46px"
            :multiple-limit="3"
            multiple
            v-model="formData.user_remark_022"
            placeholder="请选择"
            popper-class="customselect-popper"
            value-key="value"
            otherValue="6030"
          >
            <el-option
              v-for="(item, idx) in domainOptions"
              :key="idx"
              :label="item.text"
              :value="item"
              :remark="item.value"
            >
            </el-option>
          </CustomSelect>
        </el-form-item>
        <div class="buttons">
          <template v-if="!formDataModifyStatus.user_remark_022">
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_022', 1)
              "
              >修改
            </el-button>
          </template>
          <template v-if="formDataModifyStatus.user_remark_022">
            <el-button
              class="custom-button btn-determine btn-modify"
              @click="
                handleToConfirm('formDataModifyStatus', 'user_remark_022')
              "
              >确定
            </el-button>
            <el-button
              class="custom-button btn-e0e0e0 btn-modify"
              @click="
                handleToModify('formDataModifyStatus', 'user_remark_022', 0)
              "
              >取消
            </el-button>
          </template>
        </div>
      </div>
      <div class="form-item form-item-normal" v-show="isPublicist">
        <el-form-item label="全网粉丝量:" prop="user_remark_021" :rules="rules.user_remark_021">
          <el-input
            disabled
            class="custom-input width690"
            :value="formData.user_remark_021?formData.user_remark_021:0"
          ></el-input>
        </el-form-item>
        <div class="buttons">
          <el-button
            class="custom-button btn-determine btn-modify"
            @click="goEidt"
          >去编辑</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { Base64 } from "js-base64";
import storage from "@/utils/customLocalStorage";
import {mailValidator, phoneValidator} from "@/assets/js/util";
import CustomSelect from "@/components/CustomSelect.vue";
import CustomSelectCity from "@/components/CustomSelectCity.vue";
import cityData from "@/utils/cityjs/developaddress";
import {developLangOptions, hotCites, identityOptionsRegister, industryOptions, domainOptions} from "@/assets/js/dictionary";
import lodash from "lodash";
import pageCommon from "@/utils/pagecommon";
import accountApi from "@/api/account";
import bugApi from "@/api/bug";
export default {
  name: "MyBasics",
  components: { CustomSelect, CustomSelectCity },
  created() {
    let _this = this;
    _this.cityOptions = _this.hotCites;
    _this.getUserInfo();
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 8);
  },
  data() {
    return {
      identityOptionsRegister: lodash.cloneDeep(identityOptionsRegister),
      devlangOptions: lodash.cloneDeep(developLangOptions),
      industryOptions: lodash.cloneDeep(industryOptions),
      domainOptions: lodash.cloneDeep(domainOptions),
      origin_identityOptionsRegister: [],
      origin_devlangOptions: [],
      origin_industryOptions: [],
      origin_domainOptions: [],
      hotCites: lodash.cloneDeep(hotCites),
      cityOptions: [],
      userType: 1,
      formData: {
        id_public_user_info: "",
        user_remark_001: "101",
        user_remark_002: [], //用户身份
        user_remark_005: "", //公司名称
        nick_name: "", //姓名
        user_remark_007: [], //开发地
        user_remark_006: "", //团队人数
        user_remark_008: [], //行业
        user_remark_003: [], //开发语言
        user_email: "",
        user_remark_019: "",
        user_remark_021: "",
        user_remark_022: "",
        user_remark_023: "",
      },
      orginFormData: {
        id_public_user_info: "",
        user_remark_001: "101",
        user_remark_002: [], //用户身份
        user_remark_005: "", //公司名称
        nick_name: "", //姓名
        user_remark_007: [], //开发地
        user_remark_006: "", //团队人数
        user_remark_008: [], //行业
        user_remark_003: [], //开发语言
        user_email: "",
        user_remark_019: "",
        user_remark_021: "",
        user_remark_022: "",
        user_remark_023: "",
      },
      formDataModifyStatus: {
        user_remark_002: 0,
        user_remark_005: 0,
        nick_name: 0,
        user_remark_007: 0,
        user_remark_006: 0,
        user_remark_008: 0,
        user_email: 0,
        user_remark_003: 0,
        user_remark_019: "",
        user_remark_021: "",
        user_remark_022: 0,
        user_remark_023: 0,
      },
      rules: {
        user_remark_002: [
          { required: true, message: "选择身份", trigger: "change" },
          { required: true, message: "选择身份", trigger: "blur" },
        ],
        user_remark_003: [
          { required: true, message: "选择开发语言", trigger: "change" },
        ],
        user_remark_005: [
          { required: true, message: "填写公司名称", trigger: "blur" },
        ],
        user_remark_006: [
          { required: true, message: "填写团队人数", trigger: "blur" },
        ],
        user_remark_007: [
          { required: true, message: "选择开发地", trigger: "change" },
        ],
        user_remark_008: [
          { required: true, message: "选择行业", trigger: "change" },
        ],
        user_remark_019: [
          { required: true, message: "上传营业执照", trigger: "change" },
          { min: 3, message: '上传营业执照', trigger: 'change'},
        ],
        user_remark_022: [
          { required: true, message: "选择涉猎领域", trigger: "change" },
        ],
        nick_name: [{ required: true, message: "填写姓名", trigger: "blur" }],
        user_email: [
          { required: true, message: "填写邮箱", trigger: "blur" },
          { validator: mailValidator, trigger: "blur" },
        ],
        msg_content: [
          { required: true, message: "填写手机验证码", trigger: "blur" },
        ],
        pic_code: [{ required: true, message: "填写验证码", trigger: "blur" }],
        password_user: [
          { required: true, message: "填写密码", trigger: "blur" },
        ],
        user_phone: [
          { required: true, message: "填写正确的手机号码", trigger: "blur" },
          { validator: phoneValidator, trigger: "blur" },
        ],
      },
      isRequesting: false,
      fit: 'cover'
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
    showUserType: function () {
      let _this = this;
      if (!_this.formData) {
        return "";
      }
      if (_this.formData.user_remark_001 == 101) {
        return "个人";
      }
      if (_this.formData.user_remark_001 == 102) {
        return "服务商";
      }
      return "";
    },
    isSupplier: function () {
      let _this = this;
      if (!_this.formData) {
        return false;
      }
      if (_this.formData.user_remark_001 != 102) {
        return false;
      }
      return true;
    },
    isPublicist: function () {
      let _this = this;
      if (!_this.formData) {
        return false;
      }
      if (_this.formData.user_remark_020 == 2002 || this.formData.user_remark_020 == 2003 || this.formData.user_remark_020 == 2004) {
        return true;
      }
      return false;
    },
  },
  methods: {
    getUserInfo: function () {
      let _this = this;
      pageCommon
        .apiRequestCommon(accountApi, "getUserShopInfo", {
          isloading: true,
        })
        .then(
          (res) => {
            let formData = res.public_user_info;
            console.log(formData)
            if (formData.id_public_user_info === 92) {
              _this.$router.push("/login");
            } else {
              _this.dealWithFormData(formData);
            }
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
    },
    // 作废其他跟斜杆青年身份
    filterSelect(data){
      var data_arr=[];
      if(data){
        data_arr=data.split(',');
        for (let i = data_arr.length - 1; i >= 0; i--) {
          if (data_arr[i] === '211' || data_arr[i] === '212') {
            data_arr.splice(i, 1);
          }
        }
      }
      return data_arr.join(',')
    },
    dealWithFormData: function (formData) {
      let _this = this;
      // 身份
      formData.user_remark_002=this.filterSelect(formData.user_remark_002);
      if (
        formData &&
        (formData.user_remark_002 ||
          formData.user_remark_002 === "0" ||
          formData.user_remark_002 === 0)
      ) {
        let user_remark_002_val = formData ? formData.user_remark_002 : "";
        let user_remark_009_val = formData ? formData.user_remark_009 : "";
        let user_remark_002 = _this.dealWithMultipleData(
          "identityOptionsRegister",
          user_remark_002_val,
          212,
          user_remark_009_val
        );
        formData.user_remark_002 = user_remark_002;
      } else if (formData) {
        formData.user_remark_002 = [];
      }
      // 开发语言
      if (
        formData &&
        (formData.user_remark_003 ||
          formData.user_remark_003 === "0" ||
          formData.user_remark_003 === 0)
      ) {
        let user_remark_003_val = formData ? formData.user_remark_003 : "";
        let user_remark_010_val = formData ? formData.user_remark_010 : "";
        let user_remark_003 = _this.dealWithMultipleData(
          "devlangOptions",
          user_remark_003_val,
          329,
          user_remark_010_val
        );
        formData.user_remark_003 = user_remark_003;
      } else if (formData) {
        formData.user_remark_003 = [];
      }
      //810
      if (
        formData &&
        (formData.user_remark_008 ||
          formData.user_remark_008 === "0" ||
          formData.user_remark_008 === 0)
      ) {
        let user_remark_008_val = formData ? formData.user_remark_008 : "";
        let user_remark_011_val = formData ? formData.user_remark_011 : "";
        let user_remark_008 = _this.dealWithMultipleData(
          "industryOptions",
          user_remark_008_val,
          810,
          user_remark_011_val
        );
        formData.user_remark_008 = user_remark_008;
      } else if (formData) {
        formData.user_remark_008 = [];
      }
      // 涉猎领域
      if (
        formData &&
        (formData.user_remark_022 ||
          formData.user_remark_022 === "0" ||
          formData.user_remark_022 === 0)
      ) {
        let user_remark_022_val = formData ? formData.user_remark_022 : "";
        let user_remark_023_val = formData ? formData.user_remark_023 : "";
        let user_remark_022 = _this.dealWithMultipleData(
          "domainOptions",
          user_remark_022_val,
          6030,
          user_remark_023_val
        );
        formData.user_remark_022 = user_remark_022;
      } else if (formData) {
        formData.user_remark_022 = [];
      }
      if (
        formData &&
        (formData.user_remark_007 ||
          formData.user_remark_007 === "0" ||
          formData.user_remark_007 === 0)
      ) {
        let user_remark_007_val = formData ? formData.user_remark_007 : "";
        let user_remark_007 =
          _this.dealWithDevlopAddressData(user_remark_007_val);
        formData.user_remark_007 = user_remark_007;
      } else if (formData) {
        formData.user_remark_007 = [];
      }
      if (formData.user_email) {
        const arr=formData.user_email.split('@')
        formData.user_email = formData.user_email.substring(0, 3) + '*****' + '@' + arr[1]
      }
      formData.user_remark_019 = formData.user_remark_019 ? formData.user_remark_019 : '';
      _this.formData = formData;
      _this.orginFormData = lodash.cloneDeep(formData);
    },
    dealWithMultipleData: function (
      listname,
      resdata,
      othervalue,
      other_remark_value
    ) {
      let _this = this;
      let arrRes = resdata ? resdata.split(",") : [];
      let selectedData = [];
      let list = _this[listname];
      for (let i = 0; i < arrRes.length; i++) {
        const tmpRes = arrRes[i];
        for (let j = 0; j < list.length; j++) {
          const tmpitem = list[j];
          if (tmpitem.value == tmpRes) {
            if (tmpitem.value == othervalue) {
              tmpitem.remark = other_remark_value;
            }
            selectedData.push(tmpitem);
          }
        }
      }
      _this[`origin_${listname}`] = lodash.cloneDeep(list);
      return selectedData;
    },
    dealWithDevlopAddressData: function (address) {
      let arrAddress = address ? address.split(",") : [];
      let selecteCities = [];
      for (let i = 0; i < arrAddress.length; i++) {
        const add = arrAddress[i];
        for (let j = 0; j < cityData.length; j++) {
          const city = cityData[j];
          if (city.cityid == add) {
            selecteCities.push(lodash.cloneDeep(city));
          }
        }
      }
      return selecteCities;
    },
    handleChangeLetter: function (idx) {
      let _this = this;
      let cityOptions = [];
      if (idx == -1) {
        cityOptions = _this.hotCites;
      } else {
        cityOptions = _this.getCityByIdx(idx);
      }
      _this.cityOptions = cityOptions;
    },
    getCityByIdx: function (idx) {
      let letters = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ];
      let cityOptions = [];
      for (let i = idx * 4; i < (idx + 1) * 4 && i < letters.length; i++) {
        const letter = letters[i];
        for (let j = 0; j < cityData.length; j++) {
          const city = cityData[j];
          if (city.tags.indexOf(letter) == 0) {
            cityOptions.push(city);
          }
        }
      }
      return cityOptions;
    },
    handleToModify: function (obj, prop, val) {
      let _this = this;
      _this[obj][prop] = val;
      if (!val) {
        _this.formData = lodash.cloneDeep(_this.orginFormData);
        _this.identityOptionsRegister = lodash.cloneDeep(_this.origin_identityOptionsRegister);
        _this.devlangOptions = lodash.cloneDeep(_this.origin_devlangOptions);
        _this.industryOptions = lodash.cloneDeep(_this.origin_industryOptions);
        _this.domainOptions = lodash.cloneDeep(_this.origin_domainOptions);
        _this.$refs.basicsForm.clearValidate();
      }
    },
    handleToConfirm: function (obj, prop) {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      _this.$refs["basicsForm"].validateField(prop, (valid) => {
        if (!valid) {
          let changeData = _this.dealChangUserInfo();
          _this.changeUserInfoMain(changeData, obj, prop);
          return;
        }
      });
      return;
    },
    dealChangUserInfo: function () {
      let _this = this;
      let user_remark_002_values = [];
      let user_remark_009 = "";
      if (
        _this.formData.user_remark_002 ||
        _this.formData.user_remark_002 === 0 ||
        _this.formData.user_remark_002 === "0"
      ) {
        for (let i = 0; i < _this.formData.user_remark_002.length; i++) {
          const element = _this.formData.user_remark_002[i];
          user_remark_002_values.push(element.value);
          if (element.value == "212") {
            user_remark_009 = element.remark;
          }
        }
      }
      let user_remark_003_values = [];
      let user_remark_010 = "";
      if (
        _this.formData.user_remark_003 ||
        _this.formData.user_remark_003 === 0 ||
        _this.formData.user_remark_003 === "0"
      ) {
        for (let i = 0; i < _this.formData.user_remark_003.length; i++) {
          const element = _this.formData.user_remark_003[i];
          user_remark_003_values.push(element.value);
          if (element.value == "329") {
            user_remark_010 = element.remark;
          }
        }
      }
      let user_remark_022_values = [];
      let user_remark_023 = "";
      if (
        _this.formData.user_remark_022 ||
        _this.formData.user_remark_022 === 0 ||
        _this.formData.user_remark_022 === "0"
      ) {
        for (let i = 0; i < _this.formData.user_remark_022.length; i++) {
          const element = _this.formData.user_remark_022[i];
          user_remark_022_values.push(element.value);
          if (element.value == "6030") {
            user_remark_023 = element.remark;
          }
        }
      }
      let user_remark_007_values = [];
      if (
        _this.formData.user_remark_007 ||
        _this.formData.user_remark_007 === 0 ||
        _this.formData.user_remark_007 === "0"
      ) {
        for (let i = 0; i < _this.formData.user_remark_007.length; i++) {
          const element = _this.formData.user_remark_007[i];
          user_remark_007_values.push(element.cityid);
        }
      }
      let user_remark_008_values = [];
      let user_remark_011 = "";
      if (
        _this.formData.user_remark_008 ||
        _this.formData.user_remark_008 === 0 ||
        _this.formData.user_remark_008 === "0"
      ) {
        for (let i = 0; i < _this.formData.user_remark_008.length; i++) {
          const element = _this.formData.user_remark_008[i];
          user_remark_008_values.push(element.value);
          if (element.value == "810") {
            user_remark_011 = element.remark;
          }
        }
      }
      let changeUserInfo = {
        id_public_user_info: _this.formData.id_public_user_info,
        nick_name: _this.formData.nick_name,
        user_remark_001: _this.formData.user_remark_001,
        user_remark_002: user_remark_002_values.join(","),
        user_remark_009: user_remark_009,
        user_remark_003: user_remark_003_values.join(","),
        user_remark_010: user_remark_010,
        user_remark_004: 401,
        user_remark_005: _this.formData.user_remark_005,
        user_remark_006: _this.formData.user_remark_006,
        user_remark_007: user_remark_007_values.join(","),
        user_remark_008: user_remark_008_values.join(","),
        user_remark_011: user_remark_011,
        user_remark_019: _this.formData.user_remark_019,
        user_remark_022: user_remark_022_values.join(","),
        user_remark_023: user_remark_023,
        user_email: _this.formData.user_email,
      };
      return changeUserInfo;
    },
    changeUserInfoMain: function (changeUerInfo, obj, prop) {
      let _this = this;
      let requestData = {
        id_public_user_info: changeUerInfo.id_public_user_info,
        nick_name: changeUerInfo.nick_name,
        user_remark_001: changeUerInfo.user_remark_001,
        user_remark_002: changeUerInfo.user_remark_002,
        user_remark_009: changeUerInfo.user_remark_009,
        user_remark_003: changeUerInfo.user_remark_003,
        user_remark_010: changeUerInfo.user_remark_010,
        user_remark_004: changeUerInfo.user_remark_004,
        user_remark_005: changeUerInfo.user_remark_005,
        user_remark_006: changeUerInfo.user_remark_006,
        user_remark_007: changeUerInfo.user_remark_007,
        user_remark_008: changeUerInfo.user_remark_008,
        user_remark_011: changeUerInfo.user_remark_011,
        user_remark_019: changeUerInfo.user_remark_019,
        user_remark_022: changeUerInfo.user_remark_022,
        user_remark_023: changeUerInfo.user_remark_023,
        user_email: changeUerInfo.user_email,
        isloading: true,
      };
      // bug清单列表
      let bug_list_page_content = {
        pre_db_para_id_public_user_info: changeUerInfo.id_public_user_info,
        mid_table_remark_009: changeUerInfo.nick_name,
        id_public_middle_table:-1,
        isloading: true,
      };
      pageCommon
        .apiRequestCommon(accountApi, "changeUerInfo", requestData)
        .then(
          (res) => {
            _this.isRequesting = false;
            _this.$message.success("修改成功");
            _this.$store.dispatch("acUser", res.public_user_info);
            storage.set("user", JSON.stringify(res.public_user_info));
            // _this.getUserInfo();
            _this.dealWithFormData(res.public_user_info);
            _this[obj][prop] = 0;
            // BUG清单8004这个表的名字修改
            pageCommon.apiRequestCommon(bugApi, "createBug", bug_list_page_content).then(
              (res) => {
                _this.isRequesting = false;
              },
              (err) => {
                _this.isRequesting = false;
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                  _this.$message.error(err.data.msg);
                }
              }
            );
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
    },
    handleChangeFile: function (file) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("营业执照不能超过 50MB!");
        return;
      }
      const loading = _this.$loading({});
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          console.log(res)
          _this.formData.user_remark_019=res;
          _this.isRequesting = false;
          setTimeout(() => {
            loading.close();
          }, 2000);
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
          setTimeout(() => {
            loading.close();
          }, 2000);
        }
      );
    },
    goEidt: function () {
      this.$router.push({
        path: "/myBasicsEdit",
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.mybasics {
  margin-left: 40px;
  .width100per {
    width: 100%;
  }
  .title {
    font-size: 26px;
    font-family: "SourceHanSansCN";
    color: rgb(34, 34, 34);
    font-weight: bold;
    margin-top: 40px;
    text-align: left;
  }
  .basics-form,
  .myaccount-peopleform,
  .myaccount-supplierform {
    position: relative;
    margin-top: 40px;
    .form-item {
      width: 990px;
      display: flex;
      align-items: center;
      &.form-item-base {
        margin-bottom: 30px;
        .form-item-usertype {
          margin-left: 45px;
        }
      }
      &.form-item-normal {
        padding-top: 30px;
        padding-bottom: 8px;
        box-sizing: border-box;
        border-top: 1px solid rgb(238, 238, 238);
        &.upload{
          align-items: flex-end;
        }
        .buttons {
          display: flex;
          align-items: center;
          .custom-button {
            margin-left: 10px;
            &:first-child {
              margin-left: 30px;
            }
          }
        }
      }
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-family: "SourceHanSansCN";
        color: rgba(153, 153, 153, 1);
      }
      .txt-normalstyle {
        height: 46px;
        line-height: 46px;
        font-size: 16px;
        font-family: "SourceHanSansCN";
        color: rgba(102, 102, 102, 1);
      }
      .width690 {
        width: 690px;
      }
      .width270 {
        width: 270px;
      }
      .btn-modify {
        width: 80px;
        height: 46px;
        line-height: 46px;
        font-size: 16px;
        margin-bottom: 22px;
      }
    }
    .line {
      width: 100%;
      height: 1px;
      border-bottom: 1px solid rgb(238, 238, 238);
      margin: 30px 0;
      box-sizing: border-box;
    }
  }
}
</style>
<style lang="less">
  .upload-qualifications{
    width: 320px;
    height: 226px;
    background: #FFFFFF;
    border: 1px solid #F0F0F0;
    border-radius: 4px;
    padding:5px;
    .el-upload--text{
      width:100%;
      height:100%;
    }
    .inner-qualifications{
      width:100%;
      height:100%;
    }
    .inner-qualifications-null{
      width:100%;
      height:100%;
      background-size:100%;
      background-position:center;
      background-repeat:no-repeat;
      background-image:url(~@/assets/basics_certificate_bg.jpg);
    }
  }
</style>
